import { ImageProps } from './types';

const Image = (props: ImageProps) => {
  const { alt, src, sx } = props;
  return <img src={src} alt={alt} style={sx} />;
};

export default Image;
